import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  container: {
    position: 'relative',
    display: 'flex',
    backgroundImage: 'linear-gradient(to bottom right, #C795DD, #412167)',
    height: '660px',
    pr: '20px',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: 'fit-content',
      alignItems: 'center',
      pr: '0px',
    },
  },

  box: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    pl: '144px',
    pt: '250px',

    [theme.breakpoints.down('md')]: {
      width: '80%',
      pl: '0px',
      pt: '80px',
      alignItems: 'center',
    },
  },

  image: {
    position: 'relative',
    mt: '120px',
    ml: '5%',
    width: '650px',
    height: '400px',

    [theme.breakpoints.between('md', 'lg')]: {
      ml: '10px',
    },

    [theme.breakpoints.down('md')]: {
      mt: '64px',
      mb: '80px',
      ml: '0px',
      width: '330px',
      height: '240px',
    },
  },

  text: {
    color: 'white',
    mt: '40px',
  },

  whiteText: {
    color: 'white',
  },
});
